import { useEffect } from "react";

const useGlobalScroll = () => {
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      html.lock-scroll {
        overflow: hidden;
      }
    `;
    document.head.appendChild(styleTag);
    document.documentElement.classList.add("lock-scroll");

    return () => {
      document.documentElement.classList.remove("lock-scroll");
      document.head.removeChild(styleTag);
    };
  }, []);
};

export default useGlobalScroll;
